// src/monitoring/appInsights.ts
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

// const appInsights = new ApplicationInsights({
//   config: {
//     connectionString: import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING,
//     enableAutoRouteTracking: true,
//     enableAjaxErrorStatusText: true,
//     enableCorsCorrelation: true,
//     disableExceptionTracking: false,
//   },
// });

const appInsights = new ApplicationInsights({
  config: {
    connectionString: import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING,

    // --- your existing settings ---
    enableAutoRouteTracking: true,
    enableAjaxErrorStatusText: true,
    disableExceptionTracking: false,

    // --- CORS/Google APIs fix ---
    // 1) Don't inject correlation headers for Google APIs (no Request-Id / traceparent, etc.)
    //    Use the exact host(s) you call. You can add more if needed.
    correlationHeaderExcludedDomains: [
      'maps.googleapis.com', // Google Time Zone API
      // 'www.googleapis.com', // (example) other Google REST endpoints
    ],

    // 2) Also disable CORS correlation to avoid any extra AI CORS headers
    enableCorsCorrelation: false,

    // If you STILL see preflight issues with other third-party APIs,
    // uncomment one or both "big hammers" below to stop AI from touching network calls:
    // disableFetchTracking: true,
    // disableAjaxTracking: true,
  },
});

export function initAppInsights(): void {
  // Only initialize for allowed environments
  const allowedModes = [
    'legacy',
    'development',
    'production',
    'staging',
    'full',
  ];
  if (allowedModes.includes(import.meta.env.MODE)) {
    appInsights.loadAppInsights();
    appInsights.trackPageView(); // Initial load
  }
}

export { appInsights };
